import styled from "styled-components";

export const ProductRoadmap = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.875rem;
  padding-bottom: 1rem;
`;

export const Date = styled.span`
  font-weight: 300;
`;

export const Summary = styled.p`
  font-weight: 300;
  font-size: 0.938rem;
  line-height: 1.4rem;
  width: 70%;
`;
